var baseH = 'https://linestogo.logika.net';
//var baseH = "https://linestogo.fusionbot.com";
var delayH = 100;
var defYearH = '',
	defMakeH = '',
	defModelH = '',
	defEngineH = '',
	defPartH = '';
var baseYearsH;
$(function () {
	//{{{
	baseYearsH = [
		'2021',
        '2020',
		'2019',
		'2018',
		'2017',
		'2016',
		'2015',
		'2014',
		'2013',
		'2012',
		'2011',
		'2010',
		'2009',
		'2008',
		'2007',
		'2006',
		'2005',
		'2004',
		'2003',
		'2002',
		'2001',
		'2000',
		'1999',
		'1998',
		'1997',
		'1996',
		'1995',
		'1994',
		'1993',
		'1992',
		'1991',
		'1990',
		'1989',
		'1988',
		'1987',
		'1986',
		'1985',
		'1984',
		'1983',
		'1982',
		'1981',
		'1980',
		'1979',
		'1978',
		'1977',
		'1976',
		'1975',
		'1974',
		'1973',
	];
	setYearsH(baseYearsH);
	setMakesH();
	setModelsH();
	$('select#makeH').select2('enable', false);
	$('select#modelH').select2('enable', false);

	$('select#yearH').change(function () {
		if ($(this).val().length) {
			setTimeout(function () {
				$.getJSON(
					baseH + '/ajax/makes?callback=?',
					{ year: $('select#yearH').val() },
					function (j) {
						setMakesH(j);
						setModelsH();
						$('select#makeH').select2('enable', true);
						$('select#modelH').select2('enable', false);
					}
				);
			}, delayH);
		} else {
			setMakesH();
			setModelsH();
			$('select#makeH').select2('enable', false);
			$('select#modelH').select2('enable', false);
		}
	});

	$('select#makeH').change(function () {
		if ($(this).val().length) {
			setTimeout(function () {
				$.getJSON(
					baseH + '/ajax/models?callback=?',
					{
						year: $('select#yearH').val(),
						make: $('select#makeH').val(),
					},
					function (j) {
						setModelsH(j);
						$('select#modelH').select2('enable', true);
					}
				);
			}, delayH);
		} else {
			setModelsH();
			$('select#modelH').select2('enable', false);
		}
	});

	$('select#XmodelH').change(function () {
		//this is where we redirect to /product-finder
		getResultsH();
	});

	$('#finder-getParts-btn').click(function () {
		//this is where we redirect to /product-finder
		if (
			$('#select2-yearH-container').text() == 'Select a Year' ||
			$('#select2-makeH-container').text() == 'Select a Make' ||
			$('#select2-modelH-container').text() == 'Select a Model'
		) {
			//return false;
			event.preventDefault();
			$('#pfErrorDiv').slideDown('slow').delay(3000).slideUp('slow');
		} else {
			console.log('submitting');
			getResultsH();
		}
	});

	$('input#resetH').click(function () {
		setYearsH(baseYearsH);
		setMakesH();
		setModelsH();
		$('select#makeH').select2('enable', false);
		$('select#modelH').select2('enable', false);
	});
}); //}}}
function safeH(text) {
	//{{{
	if (text !== null)
		return text
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	else return '';
} //}}}
function setYearsH(j) {
	//{{{
	var options = '<option value="">Select a Year</option>';
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defYearH && defYearH != '' ? ' selected' : '';
		options +=
			'<option value="' +
			j[i] +
			'"' +
			selected +
			'>' +
			safeH(j[i]) +
			'</option>';
	}
	$('select#yearH').html(options);
	$('select#yearH').select2({ minimumResultsForSearch: 5 });
} //}}}
function setMakesH(j) {
	//{{{
	var options = '<option value="">Select a Make</option>';
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defMakeH && defMakeH != '' ? ' selected' : '';
		options +=
			'<option value="' +
			j[i] +
			'"' +
			selected +
			'>' +
			safeH(j[i]) +
			'</option>';
	}
	$('select#makeH').html(options);
	$('select#makeH').attr('disabled', false);
	$('select#makeH').select2({ minimumResultsForSearch: 5 });
	// if (typeof j != 'undefined') $('select#makeH').select2('open');
} //}}}

function setModelsH(j) {
	//{{{
	var options = '<option value="">Select a Model</option>';
	for (var i = 0; i < (typeof j == 'undefined' ? 0 : j.length); i++) {
		var selected = j[i] == defModelH && defModelH != '' ? ' selected' : '';
		options +=
			'<option value="' +
			j[i] +
			'"' +
			selected +
			'>' +
			safeH(j[i]) +
			'</option>';
	}
	$('select#modelH').html(options);
	$('select#modelH').attr('disabled', false);
	$('select#modelH').select2({ minimumResultsForSearch: 5 });
	// if (typeof j != 'undefined') $('select#modelH').select2('open');
} //}}}

function clearFormH() {
	//{{{
	$.cookie('yearH', '', { path: '/' });
	$.cookie('makeH', '', { path: '/' });
	$.cookie('modelH', '', { path: '/' });
	setYearsH(baseYearsH);
	setMakesH();
	setModelsH();
	return false;
} //}}}

function getResultsH() {
	$('#finderH').submit();
}
